import { render, staticRenderFns } from "./Settlement.vue?vue&type=template&id=b13ae0cc&scoped=true&"
import script from "./Settlement.vue?vue&type=script&lang=ts&"
export * from "./Settlement.vue?vue&type=script&lang=ts&"
import style0 from "./Settlement.vue?vue&type=style&index=0&id=b13ae0cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13ae0cc",
  null
  
)

export default component.exports